import { render, staticRenderFns } from "./FSAccordion.vue?vue&type=template&id=bb8b6a84&"
import script from "./FSAccordion.vue?vue&type=script&lang=js&"
export * from "./FSAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports